import { render, staticRenderFns } from "./form-consumer.vue?vue&type=template&id=46072896&scoped=true&"
import script from "./form-consumer.vue?vue&type=script&lang=js&"
export * from "./form-consumer.vue?vue&type=script&lang=js&"
import style0 from "./form-consumer.vue?vue&type=style&index=0&id=46072896&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46072896",
  null
  
)

export default component.exports